(function () {
  function isDesktop() {
    return window.matchMedia("(min-width: 769px)").matches;
  }

  function isVisible(el) {
    if (!el) return false;
    return window.getComputedStyle(el).display !== "none";
  }

  function loadVisibleBookingMood() {
    document.querySelectorAll(".loven-dates__embed iframe[data-src]").forEach(function (iframe) {
      if (iframe.getAttribute("src")) return;
      var hideRoot = iframe.closest(".small--hide, .medium-up--hide, .loven-product__aside");
      if (hideRoot && !isVisible(hideRoot)) return;
      iframe.src = iframe.getAttribute("data-src");
    });
  }

  function headerOffset() {
    var header = document.querySelector(".site-header");
    if (!header) return 72;
    return Math.round(header.getBoundingClientRect().height) + 8;
  }

  function scrollToCalendar(event) {
    var target = document.getElementById("calendar");
    if (!target) return;
    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    // 01/10/2026 : le tap sur « Voir les dates » ouvre le calendrier du widget
    // v2 au lieu de seulement faire défiler. Si le widget est retombé sur
    // l'iframe Bookingmood, il n'y a pas de bouton : le défilement suffit.
    var opener = target.querySelector('.loven-booking [data-act="calendar"]');
    if (opener) opener.click();
  }

  // La barre se cache dès que le bouton de réservation du widget (ou, à
  // défaut, le bloc calendrier) est visible au-dessus d'elle : le visiteur a
  // alors le vrai CTA sous le pouce et la barre ne recouvre plus la carte.
  // Exposé pour les tests (tests/loven-product-hybrid.test.js).
  function shouldHideBar(rect, viewportHeight, barHeight) {
    if (!rect) return false;
    var limit = viewportHeight - barHeight;
    return rect.top < limit && rect.bottom > 0;
  }

  function initStickyBar() {
    var bar = document.querySelector("[data-loven-sticky-bar]");
    var calendar = document.getElementById("calendar");
    if (!bar || !calendar) return;

    var cta = bar.querySelector('a[href="#calendar"]');
    if (cta) cta.addEventListener("click", scrollToCalendar);

    if (isDesktop()) return;

    var panel = calendar.querySelector(".loven-dates") || calendar;
    var ticking = false;

    function cible() {
      // Le widget redessine son DOM à chaque rendu : on relit le bouton à
      // chaque mesure plutôt que d'observer un élément qui sera remplacé.
      return calendar.querySelector(".loven-booking .lb-cta") || panel;
    }

    function mesurer() {
      ticking = false;
      var hidden = shouldHideBar(cible().getBoundingClientRect(), window.innerHeight, bar.offsetHeight || 72);
      bar.classList.toggle("is-hidden", hidden);
      document.body.classList.toggle("loven-sticky-bar-hidden", hidden);
    }

    function planifier() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(mesurer);
    }

    window.addEventListener("scroll", planifier, { passive: true });
    window.addEventListener("resize", planifier);
    mesurer();
    // Le widget rend son CTA après l'appel réseau : on remesure pendant les
    // premières secondes, puis les événements scroll/resize suffisent.
    var essais = 0;
    var timer = window.setInterval(function () {
      mesurer();
      if (++essais >= 10) window.clearInterval(timer);
    }, 500);
  }

  // Bandeau « Dernière minute » : la date limite est rendue en Liquid au format
  // court (6/10), juste sans JavaScript. On la réécrit ici en toutes lettres,
  // et surtout on la RECALCULE : une page servie depuis le cache aurait sinon
  // annoncé la date limite de la veille. Le seuil se compte en dates, du jour
  // en cours à la date d'arrivée, jamais en heures restantes (règle 01/10/2026).
  // Le jour en cours est celui de Paris, pas celui du navigateur : un visiteur
  // de La Réunion ou de Nouvelle-Calédonie est déjà au lendemain en soirée
  // parisienne et verrait une date limite d'un jour de trop. La note du
  // bandeau promet « heure de Paris », on la tient.
  function aujourdHuiParis(maintenant) {
    try {
      var s = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit"
      }).format(maintenant);
      var p = s.split("-");
      return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    } catch (e) {
      return new Date(maintenant.getFullYear(), maintenant.getMonth(), maintenant.getDate());
    }
  }

  function dateLimiteLastMinute(jours, maintenant) {
    var d = aujourdHuiParis(maintenant);
    d.setDate(d.getDate() + jours);
    return d;
  }

  function iso(d) {
    function p(n) { return (n < 10 ? "0" : "") + n; }
    return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate());
  }

  function majLastMinute() {
    var blocs = document.querySelectorAll("[data-lns-last-minute]");
    for (var i = 0; i < blocs.length; i++) {
      var bloc = blocs[i];
      var jours = parseInt(bloc.getAttribute("data-days"), 10);
      // 0 et 1 s'écrivent « aujourd'hui » / « aujourd'hui ou demain » : rien à dater.
      if (isNaN(jours) || jours < 2) continue;
      var cible = bloc.querySelector("[data-lns-lm-date]");
      if (!cible) continue;
      var limite = dateLimiteLastMinute(jours, new Date());
      var texte;
      try {
        texte = limite.toLocaleDateString(document.documentElement.lang || "fr-FR", {
          weekday: "long", day: "numeric", month: "long"
        });
      } catch (e) {
        texte = limite.getDate() + "/" + (limite.getMonth() + 1);
      }
      cible.textContent = texte;
      cible.setAttribute("datetime", iso(limite));
      var note = bloc.querySelector("[data-lns-lm-iso]");
      if (note) note.setAttribute("data-lns-lm-iso", iso(limite));
    }
  }

  window.__lovenHybrid = {
    shouldHideBar: shouldHideBar,
    headerOffset: headerOffset,
    aujourdHuiParis: aujourdHuiParis,
    dateLimiteLastMinute: dateLimiteLastMinute,
    majLastMinute: majLastMinute
  };

  function toggleReadMore(btn) {
    var container = btn.closest(".read-more-container");
    if (!container) return;
    var expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    container.classList.toggle("is-open", !expanded);
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".read-more-btn");
    if (!btn) return;
    event.preventDefault();
    toggleReadMore(btn);
  });

  loadVisibleBookingMood();
  initStickyBar();
  majLastMinute();
  window.addEventListener("resize", loadVisibleBookingMood);
})();
